<template>
  <div>
    <div class="main-container" v-show="isShow">
      <div class="table-header">
        <a-button type="primary" class="addbtn" @click="openModal(1)">
            +&nbsp 添加一级类目
          </a-button>
      </div>
      <a-table 
        :locale="{
          emptyText: '暂无数据'
        }"
        rowKey="id" 
        :columns="columns" 
        :data-source="data" 
        @change="handleTableChange" 
        :pagination="pagination"  
        style="margin-top:12px;"
      >
        <a slot="categoryName" slot-scope="text,record" @click="openModal(3,record)">{{text}}</a>
        <span slot="level">一级</span>
        <a slot="action" slot-scope="text" @click="openModal(2,text)">编辑</a>
      </a-table>
      <add-category ref="addAccount" @getdata="getdata" title="一级"></add-category>
      <edit-category ref="editAccount" @getdata="getdata" title="一级"></edit-category>
    </div>
    <router-view/>
  </div>
</template>
<script>
import page from "@/assets/mixin/page.js";
import addCategory from "./components/addCategory"
import editCategory from "./components/editCategory"
const columns = [
  {
    title: '分类名称',
    dataIndex: 'categoryName',
    key: 'categoryName',
    width:"25%",
    scopedSlots: { customRender: 'categoryName' },
  },
  {
    title: '级别',
    key: 'level',
    width:"25%",
    scopedSlots: { customRender: 'level' },
  },
  {
    title: '创建时间',
    key: 'createTime',
    width:"25%",
    dataIndex:'createTime',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  mixins: [page],
  components:{addCategory,editCategory},
  computed: {
    isShow() {
      return this.$route.name === "category-manage";
    },
  },
  data() {
    return {
      data:[],
      columns,
    };
  },
  created(){
    this.getdata()
  },
  methods:{
    getdata(){
      this.$http.post('primaryCategory/queryRecordList',{pageNum:this.pagination.current}).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;
      })
    },
    openModal(index,params){
      if (index=='1') {
        this.$refs.addAccount.showModal()
      } else if(index=='2') {
        this.$refs.editAccount.showModal(params)
      }else if(index=='3') {
        this.$router.push({name:'sub-category',query: { id: params.id ,btitle:params.categoryName}  })
      }
    }
  }
};
</script>
<style lang="less" scoped>
.search-box{
  padding: 29px 24px;
  height: 80px;
  margin-bottom: 24px;
  background-color: rgb(247, 248, 249);
  .ant-btn{
    margin-right: 8px;
  }
  .ant-input{
    width: 216px;
    margin-right: 80px;
  }
}
.table-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .addbtn{
    
  }
}

</style>
